export default __webpack_public_path__ + "static/media/tether_usdt_green_icon.3cc2522e.svg";